export default function PHP_ftp_chmod() {
  return (
    <div>
      <h1>PHP_ftp_chmod</h1>
    </div>
  );
}
